import React from "react";
import { ApiResult } from "../../lib/CmsApi";
import MagazineDetailPage from "./MagazineDetailPage";
import CustomPageHead from "../common/CustomPageHead";
import Seo from "../../lib/models/seo";
import FundingStoriesSection from "../sections/FundingStories";
export interface Props {
  content: ApiResult<"loadMagazinPortraitsBySlug">;
  relatedPortraits: ApiResult<"listMagazinPortraits">;
  seo?: Seo;
}
export default function PortraitDetailPage({
  content,
  relatedPortraits,
  seo
}: Props) {
  return (
    <>
      <CustomPageHead title={content.title} seo={content.seo} />
      <MagazineDetailPage
        content={content}
        breadCrumpPath={[
          {
            route: "portraits",
            title: "Förderportraits"
          },
          {
            route: "portraitArticle",
            title: content.title,
            params: {
              slug: content.slug
            }
          }
        ]}
        relatedPortraits={relatedPortraits}
        showFirstCategory
      />
    </>
  );
}

PortraitDetailPage.getImages = (p: Props) => {
  let images = MagazineDetailPage.getImages({
    content: p.content
  });
  images = images.concat(
    p.relatedPortraits.items.map(n => n.headerImage).filter(Boolean)
  );
  return images;
};
